const radarData = [
    {
        "question": "Out of the following, what would you like to accomplish? | I try really hard but no matter how much I try I don't get better so I would like this to change",
        "my_response": 52, // no of students who answered my_response
        "child_1_name": 54,
        "dad_name": 96,
        // "answer_4": 34,
        // "answer_5": 100
    },
    {
        "question": "Tell me about your memory | I am better at remembering facts, formula and figures but not that good at remembering large pieces of text and chunks of information",
        "my_response": 68,
        "child_1_name": 28,
        "dad_name": 64,
        // "answer_4": 100,
        // "answer_5": 100
    },
    {
        "question": "Tell me about how organised you are | I am extremely organised; I hate not being organised.  I plan everything the night before and ensure my homework is always completed and handed in ahead of schedule",
        "my_response": 80,
        "child_1_name": 38,
        "dad_name": 14,
        // "answer_4":23,
        // "answer_5": 100
    },
    {
        "question": "On a scale of 1-10, 10 being so much energy and 1 being none at all how do you feel mostly at school? | 5-7 (I am ok, somewhere in the middle between no energy and lots of energy)",
        "my_response": 80,
        "child_1_name": 38,
        "dad_name": 0,
        // "answer_4":23,
        // "answer_5": 100
    },
    {
        "question": "Out of the following, what would you like to achieve the most this year in class (you can only pick one so think carefully)? | Make reading a lot easier than it is now",
        "my_response": 80,
        "child_1_name": 38,
        "dad_name": 14,
        // "answer_4":23,
        // "answer_5": 100
    },
]

export default radarData;


// WEBPACK FOOTER //
// ./src/assets/data/sampleradardata.ts